import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-roles-modal',
  templateUrl: './roles-modal.component.html',
  styleUrls: ['./roles-modal.component.css']
})
export class RolesModalComponent implements OnInit, OnDestroy {

  @ViewChild('values', { static: false }) valueRef: ElementRef | undefined;

  @Input() rolesData: any;
  @Input() rolesAdd: any;
  @Input() rolesView: any;
  @Input() rolesEdit: any;
  @Input() tabType: any;

  rolesForm: FormGroup;
  type: any;
  roleTypeList: any = [];
  formSubmitted: boolean = false;
  isShown: any;
  existingClicked: boolean = false;
  roles: any = [];
  errorMessage: any = null;

  private _loading: boolean = false;
  private _itemClicked: boolean = false;
  private _selectedItems: any = [];
  private _afterClosedSubscription: Subscription;
  private _availableRolesSubscription: Subscription;
  private _roleTypesSubscription: Subscription;
  private _saveRoleSubscription: Subscription;
  private _updateSaveRoleSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog  
  ) {
    this.rolesForm = this._fb.group({
      roleList: [''],
      roleName: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      roleTypeId: ['', [Validators.required]],
      type: [''],
      description: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
  }

  ngOnInit(): void {
    this._checkValidity();
    this._listRoleTypes();
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._availableRolesSubscription?.unsubscribe();  
    this._roleTypesSubscription?.unsubscribe();  
    this._saveRoleSubscription?.unsubscribe();  
    this._updateSaveRoleSubscription?.unsubscribe();  
    
  }
  closeModal() {
    if (this.rolesForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }

  onChangeAdd(item: any) {
    this.rolesForm.reset();
    if (item.value === 'new') {
      this._itemClicked = true;
      this.existingClicked = false;
      if (!this.existingClicked) {
        this.rolesForm.controls['roleName'].enable();
        this.rolesForm.controls['roleTypeId'].enable();
        this.rolesForm.controls['description'].enable();
      }
    } else {
      this._itemClicked = false;
      this.existingClicked = true;
      if (this.existingClicked) {
        this.rolesForm.controls['roleName'].disable();
        this.rolesForm.controls['roleTypeId'].disable();
        this.rolesForm.controls['description'].disable();
      }
    }
  }

  getValues(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        this._selectedItems = event.source.value;
        this._loadRoleData();
      }
    }
  }
  onSubmit() {
    this.formSubmitted = true;
    if (this.rolesForm.invalid) {
      return;
    }
    if (this.rolesAdd) {
      this._saveRoles();
    } else if (this.rolesEdit) {
      this._updateRoles();
    }
  }

  get formValues() {
    return this.rolesForm.controls;
  }

  private _checkValidity() {
    if (this.tabType === 'tenant') {
      this.isShown = 'tenant';
      this._availableRoles();
    } else if (this.tabType === 'global') {
      this.isShown = 'global';
    }
  }
  private _loadRoleData() {
    if (this._selectedItems) {
      let arr = this.roles.find((x: any) => x.roleName === this._selectedItems);
      if (arr) {
        this.formValues['roleName'].patchValue(arr.roleName);
        this.formValues['roleList'].patchValue(this._selectedItems);
        this.formValues['roleTypeId'].patchValue(arr.roleTypeId);
        this.formValues['description'].patchValue(arr.description);
        this.formValues['type'].patchValue(arr.type);
      }
    }
  }

  private _availableRoles() {
    this.roles = [];
    this._availableRolesSubscription = this._service.availableRoles().subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length > 0) {
          this.roles = result['response'];
        }
      }
    });
  }

  private _listRoleTypes() {
    this.roleTypeList = [];
    this._roleTypesSubscription = this._service.roleTypes().subscribe((result: any) => {
      if (result['status']) {
        if (result['response']['data'].length > 0) {
          this.roleTypeList = result['response']['data'];
        }
      }
    });
  }

  private _loadConfigurationModalData() {
    this.type = this._service.getConfiguration('typ') ? this._service.getConfiguration('typ').scope : [];
    if (this.rolesData) {
      if (this.rolesView) {
        this.rolesForm.disable();
      }
    }
    this._patchValues();
  }

  //   this._loading = true;
  //   this._service.configurationsInfo(this.attributes).subscribe((results: any) => {
  //     this._loading = false;
  //     let configList: any = results['response'];
  //     configList.forEach((element: any) => {
  //       if (element['attribute'] === 'typ') {
  //         this.type = element['values'].scope;
  //       }
  //     })
  //     if (this.rolesData) {
  //       if (this.rolesView) {
  //         this.rolesForm.disable();
  //       }
  //     }
  //     this.patchValues();
  //   });
  // }

  private _patchValues() {
    if (this.rolesAdd) {
      this.rolesForm.patchValue({
        roleName: this.rolesForm.value.roleName,
        description: this.rolesForm.value.description,
        roleTypeId: this.rolesForm.value._id,
        type: 'global'
      });
    } else {
      this.rolesForm.patchValue({
        roleName: this.rolesData.roleName,
        description: this.rolesData.description,
        type: this.rolesData.type,
        roleTypeId: this.rolesData.roletypes[0]._id
      });
    }
  }

 
  private _saveRoles() {
    this.errorMessage = null;
    this._loading = true;
    let postData;
    let data = this.rolesForm.getRawValue();
    data.group = this.tabType === 'global' ? 'system' : 'userdefined';
    data.metadata = {
      'createdBy': localStorage.getItem('userId') ?
        localStorage.getItem('userId') : null
    };

    switch (this.tabType) {
      case 'site': data.type = 'site'
        break;
      case 'tenant': data.type = 'tenant'
        break;
      case 'global': data.type = data.type
        break;
      default:
        break;
    }

    postData = { set: data };

    this._saveRoleSubscription = this._service.saveRole(postData).subscribe((result: any) => {
      if (result['status'] && result['response']) {
        if (result['status']) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result['response']) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    });
  }

  private _updateRoles() {
    this.errorMessage = null;
    this._loading = true;
    let postData;

    if (!this.rolesForm.controls['description'].dirty) {
      this.rolesForm.value.description = null;
      this.rolesForm.controls['description'].clearValidators();
    }
    if (!this.rolesForm.controls['roleName'].dirty) {
      this.rolesForm.value.roleName = null;
      this.rolesForm.controls['roleName'].clearValidators();
    }
    if (!this.rolesForm.controls['roleTypeId'].dirty) {
      this.rolesForm.value.roleTypeId = null;
      this.rolesForm.controls['roleTypeId'].clearValidators();
    }
    postData = { roleId: this.rolesData['_id'], set: this.rolesForm.value };

    this._updateSaveRoleSubscription = this._service.saveRole(postData).subscribe((result: any) => {
      if (result['status'] && result['response']) {
        if (result['status']) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result['response']) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    });
  }

}
